<div [ngClass]="userType === 'buyer' ? 'main-layout-buyer' : 'main-layout-supplier' ">
	<!-- class="main-layout" -->
    <div class="product-layout">
        <span class="product-title d-block mt-1">
			{{ selectedProduct[currentLanguage === 'en' ? 'nameEN'
			: 'nameDE'] }}
		</span>

        <nz-divider class="divider"></nz-divider>
        <div nz-row [nzGutter]="5">
            <div nz-col [nzSpan]="24">
                <span class="product-label">
					{{'global.common.comments.description' | translate}}
				</span>
            </div>
            <div nz-col [nzSpan]="24">
                {{ selectedProduct[currentLanguage === 'en' ? 'descriptionEN' : 'descriptionDE'] }}
            </div>
            <div class="mt-1" nz-col [nzSpan]="24" *ngIf="attachments?.length">
                <span class="product-label">
					{{'global.common.comments.tender_attachments' | translate}} :
					<a (click)="tenderAttachments(true)">
						{{ attachments.length }} {{ "global.buyer.tender.attachments.title" | translate }}</a>
				</span>
            </div>
        </div>

        <nz-divider style="margin-bottom: 0px;" [nzText]="'global.common.comments.stickyComments' | translate">
        </nz-divider>
    </div>
    <div class="sticky-comments">
        <nz-list *ngIf="filterStickyComments.length" [nzDataSource]="filterStickyComments" [nzRenderItem]="item" [nzItemLayout]="'horizontal'">
            <ng-template #item let-item>
                <nz-comment [nzAuthor]="item.author" [ngClass]="userType === 'supplier' ? 'sticky-comment-wrapper-supplier' : 'sticky-comment-wrapper-buyer'" [nzDatetime]="item.sentOn">
                    <nz-avatar nz-comment-avatar [nzSrc]="item.avatar"></nz-avatar>
                    <nz-comment-content>
                        <div [ngClass]="userType === 'supplier' ? 'left-sticky-comment-messages' : 'right-sticky-comment-messages'">
							<p>{{ item.content }}</p>
						</div>
                        <div [ngClass]="userType === 'supplier' ? 'left-sticky-comment-attachments' : 'right-sticky-comment-attachments'"
							*ngIf="item.attachments.length" style="flex-direction: column;">
                            <button class="border-radius-5 file-button mb-0_5 mr-0_5 ml-0_5" *ngFor="let attachment of item.attachments" (click)="onDownloadComments(selectedProduct.threads[0].threadId,item.id,attachment)" nz-button>
								<i nz-icon nzType="paper-clip" nzTheme="outline"></i>
								<span
									*ngIf="attachment.originalName.substring(0, attachment.originalName.lastIndexOf('.')).length > 25">
									{{attachment.originalName.substr(0, 25) + '...' +
									attachment.originalName.substring(attachment.originalName.lastIndexOf('.')+1)}}
								</span>
								<span
									*ngIf="!(attachment.originalName.substring(0, attachment.originalName.lastIndexOf('.')).length > 25)">
									{{attachment.originalName}}
								</span>
							</button>
                        </div>
                    </nz-comment-content>
                </nz-comment>
            </ng-template>
        </nz-list>
        <div *ngIf="!filterStickyComments.length" class="empty-comments">
            {{'global.common.comments.no_comments_yet' | translate}}
        </div>
    </div>
</div>

<nz-modal [nzStyle]="tenderAttachmentsModalStyle" class="custom-attachment-modal" nzCentered [(nzVisible)]="tenderAttachmentsModalVisible" [nzTitle]="'global.common.comments.tender_attachments' | translate" (nzOnCancel)="tenderAttachments(false)">
    <ng-container *nzModalContent>
        <nz-table nzShowSizeChanger [nzData]="['']" class="address-form mt-1 mb-2" [nzShowPagination]="false" [nzFrontPagination]="false" [nzScroll]="{ y: '500px' }">
            <thead>
                <tr>
                    <th *ngFor="let column of listOfAttachmentColumn" [nzWidth]="column?.width">
                        <span class="color-grey">{{ column.title | translate }}</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of attachments" class="editable-row">
                    <td>{{ data.originalName ? data.originalName : data.fileName }}</td>
                    <td>{{ data.size | fileSize : 2}}</td>
                    <td><a (click)="onDownloadTender(data)">{{ "global.buyer.tender.quotations.download" |
							translate }}</a>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </ng-container>
    <div *nzModalFooter>
        <button nz-button class="bg-color-blue color-white border-radius-5" (click)="tenderAttachments(false)">
			{{ "global.buyer.tender.quotations.done" | translate }}</button>
    </div>
